import { call, put, select } from 'redux-saga/effects';

import { apiCallSaga } from 'app/dealer/shared/modules/dealersInsights/redux/apiCall/sagas';
import DEALERS_INSIGHTS_API from 'app/dealer/shared/modules/dealersInsights/api/dealersInsights.api';
import {
  selectCurrentDealerId,
  selectCurrentLevel,
} from 'app/dealer/shared/modules/dealersInsights/redux/level/selectors';
import { DEALERS_INSIGHTS_LEVELS } from 'app/dealer/shared/modules/dealersInsights/redux/level/constants';

import { selectSelectedListingsBenchmarkTimeDivisionFilter } from '../timeDivision/selectors';
import { listingsApiProgressActions } from '../general/actions';
import { selectListingsBenchmarkApiDate } from '../general/selectors';

import {
  selectAllListingsBenchmarkDataValuesAreZero,
  selectListingsBenchmarkDataByDate,
} from './selectors';
import {
  getListingsBenchmarkDataSuccess,
  getListingsBenchmarkDataError,
} from './actions';

export function* getListingsDataFetchAsync() {
  const timeDivisionFilter = yield select(
    selectSelectedListingsBenchmarkTimeDivisionFilter,
  );
  const selectedApiDate = yield select(selectListingsBenchmarkApiDate);
  const currentDealerId = yield select(selectCurrentDealerId);
  const currentLevel = yield select(selectCurrentLevel);

  const params = {
    tDiv: timeDivisionFilter,
    date: selectedApiDate,
  };
  if (currentLevel === DEALERS_INSIGHTS_LEVELS.DEALER && currentDealerId) {
    params.dealerId = currentDealerId;
  }

  const listingsApiUrl = yield DEALERS_INSIGHTS_API.listings(params);
  const { result, error } = yield call(
    apiCallSaga,
    listingsApiUrl,
    listingsApiProgressActions,
  );
  if (error) {
    yield put(getListingsBenchmarkDataError(error));
  } else {
    yield put(
      getListingsBenchmarkDataSuccess({
        result,
        currentLevel,
        currentDealerId,
      }),
    );
  }
}

export function* getListingsDataAsync() {
  // select any cached listings data
  const cachedListingsDataByDate = yield select(
    selectListingsBenchmarkDataByDate,
  );

  // detect if all the values are 0 in the currently cached data set
  const allValuesAreZero = yield select(
    selectAllListingsBenchmarkDataValuesAreZero,
  );
  // if there is no cached listings data or if the all values in
  // the cached data are zero, then
  // call a GET request to fetch the needed data

  if (!cachedListingsDataByDate || allValuesAreZero) {
    yield call(getListingsDataFetchAsync);
  }
}
